import { getEnvironmentConfigs } from '../../environmentConfigs.ts';
import { initialize as initializeRollbar } from './rollbar.ts';

export async function initialize() {
  try {
    const { env } = await getEnvironmentConfigs();
    if (env === 'prod') {
      initializeRollbar();
    }
  } catch (e) {
    // biome-ignore lint/suspicious/noConsole: logging error in console
    console.error('Failed on initializing analytics tools:', e);
    return;
  }
}
